// Using Vue for the sqft calcualtor/repeater

const totalLFT = new Vue({
  el: '#LFTcalculator',

  data: {
    items: [],
    toggle: ['two'],
  },

  computed: {
    linearFeet(){
      const sum = this.items.reduce((total, item) => {
        var price = (Number(item.feet) + Number(item.inches) / 12) * Number(item.quantity);
        return total + price;
      }, 0);
      return parseInt(sum * 100) / 100;
    },
  },

  created() {
    this.addItem();
  },

  methods: {

    addItem() {
      this.items.push({
        inches: 0,
        feet: 0,
        quantity: 1,
      });
    },

    deleteItem(i) {
      this.$delete(this.items, i);
    },

    toggleItem: function (key) {
      const t = [...this.toggle];
    	var i = t.indexOf(key)
    	if (i < 0) {
      	t.push(key)
      } else {
      	t.splice(i, 1)
      }
      this.toggle = t;
    }
  },

});

  